<input
  type="radio"
  [formControl]="formControl"
  [value]="props.value"
  [id]="id"
  [attr.name]="radioName"
  class="form-check-input"
  [ngClass]="props.inputClass"
  [attr.aria-label]="props.ariaLabel | translate"
  [attr.aria-required]="props.required ? 'true' : undefined"
  [attr.aria-invalid]="showError ? 'true' : undefined"
  [attr.data-testing-id]="'radio-' + props.label"
/>
